<div class="h-group center mb-4 padded go_live_flex">
  <h3 class="title">Test Mode</h3>
  <p class="subtitle mb-4">You are still in test mode, do you want to go live?</p>
 <div class="btn_flex">
   <button class="btn btn-outline-success small mt-3" style="margin-right: 5px" (click)="goLive()">Yes</button>
   <button class="btn btn-outline-info mt-3 small" (click)="cancelGoLive()">No</button>
 </div>
</div>
